// @ts-strict-ignore
import type { useSnackBar } from '@usealloy/component-library';

import { getNumberChildActions } from 'flow/service/actions';
import {
  removeAction,
  resetNodeAndConnectorState,
  setFocusedNodeId,
  setIsTagSwapMode,
} from 'flow/store/redux/slice';
import type { WorkflowNode } from 'flow/service/graph';
import type { WorkflowState } from 'flow/store/redux/state';

import type { AppDispatch } from '~/store';

export function removeActionAndResetNodeState({
  addSnackBar,
  dispatch,
  nodeId,
}: {
  addSnackBar: ReturnType<typeof useSnackBar>;
  dispatch: AppDispatch;
  nodeId: WorkflowNode['id'];
}) {
  dispatch(removeAction({
    id: nodeId,
  }));

  addSnackBar({
    duration: 2000,
    title: 'Deleted the action.',
    type: 'success',
  });
  setTimeout(() => dispatch(resetNodeAndConnectorState()), 10);
}

export function defaultOnDeleteAction({
  addSnackBar,
  dispatch,
  nodeId,
  workflowData,
  setNodeDeletionChildActionCounts,
}: {
  addSnackBar: ReturnType<typeof useSnackBar>;
  dispatch: AppDispatch;
  nodeId: WorkflowNode['id'];
  workflowData: WorkflowState['workflowData'];
  setNodeDeletionChildActionCounts: React.Dispatch<React.SetStateAction<number>>;
}) {
  return function handler() {
    if (nodeId) {
      const childActionCounts = getNumberChildActions({
        actionPublicId: nodeId,
        workflowData,
      });

      if (childActionCounts > 0) {
        setNodeDeletionChildActionCounts(childActionCounts);
      } else {
        removeActionAndResetNodeState({
          addSnackBar,
          dispatch,
          nodeId,
        });
      }
    }
  };
}

export function defaultOnSwapAction({
  dispatch,
  nodeId,
}: {
  dispatch: AppDispatch;
  nodeId: WorkflowNode['id'];
}) {
  return function handler() {
    dispatch(setFocusedNodeId(nodeId));
    dispatch(setIsTagSwapMode(true));
  };
}

export function defaultOnUpdateAction({
  onUpdateAction,
}: {
  onUpdateAction: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return function handler() {
    onUpdateAction(true);
  };
}
